<template>
    <div>
        <b-overlay :show="loading" no-wrap rounded></b-overlay>
        <b-table  small stacked="sm" striped hover  :fields="modelColumns" :items="items" :show-empty="true"  :empty-text="this.$t('payments.noPayment')">
            <template #cell(bookingPriceTotal)="row">
              {{$root.formatLblPrice(row.item.bookingPriceTotal,row.item.bookingCurrency)}}
            </template>
            <template #cell(paymentStatus)="row">
                {{$root.getItemFromAuxVarOpts("transportServicePaymentStatusOpts",row.item.paymentStatus).text}}
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        props: {
            payment: {
                type : Object,
                required: true,
            }
        },
        data(){
            return {
                data:[],
                loading:false,
                modelColumns : [
                    {label:this.$t('payments.serviceNumber'),key:"serviceNumber"},
                    {label:this.$t('payments.paymentStatus'),key:"paymentStatus"},
                    {label:this.$t('payments.salesChannel'),key:"salesChannel.name"},
                    {label:this.$t('payments.tripType'),key:"trip"},
                    {label:"Total",key:"bookingPriceTotal"}
                ],
            }
        },
        methods:{

        },
        mounted:function(){

        },
        computed:{
            items(){
                return [...this.payment.transportServices]
            },


        },




    }
</script>
